// Enhance the normal FSE header without duplicating its logo or controls.
export const initMobileHeader = () => {
  const header = document.querySelector("#site-header.himml-header");
  const shell = header?.closest("header");
  if (!header || !shell) return;

  const mobile = window.matchMedia("(max-width: 1199px)");
  const adminBar = document.getElementById("wpadminbar");
  const adminRows = adminBar
    ? [adminBar, ...adminBar.querySelectorAll(".ab-top-menu")]
    : [];
  const menu = header.querySelector(
    ".wp-block-navigation__responsive-container"
  );
  let previousY = window.scrollY;
  let distance = 0;
  let frame = 0;
  let height = header.offsetHeight;

  shell.classList.add("himml-header-shell");
  const measure = () => {
    height = header.offsetHeight;
    shell.style.setProperty("--himml-header-height", `${height}px`);
  };
  const show = () => header.classList.remove("is-hidden");
  const update = () => {
    frame = 0;
    // Clamp elastic overscroll so iOS rubber-banding does not reverse direction.
    const maxY = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight
    );
    const y = Math.max(0, Math.min(window.scrollY, maxY));
    const delta = y - previousY;
    previousY = y;
    const adminOffset = Math.max(
      0,
      ...adminRows.map((row) => row.getBoundingClientRect().bottom)
    );
    header.style.setProperty("--himml-header-admin-offset", `${adminOffset}px`);

    if (
      !mobile.matches ||
      y <= height ||
      menu?.classList.contains("has-modal-open")
    ) {
      distance = 0;
      show();
      return;
    }
    if (!delta) return;
    distance =
      Math.sign(delta) === Math.sign(distance) ? distance + delta : delta;
    // Small direction changes should not make the header flicker.
    if (Math.abs(distance) < 12) return;
    const keyboardFocus = header.querySelector(":focus-visible");
    header.classList.toggle("is-hidden", distance > 0 && !keyboardFocus);
    distance = 0;
  };
  const queueUpdate = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const resize = () => {
    header.classList.toggle("himml-scroll-header", mobile.matches);
    measure();
    distance = 0;
    update();
  };

  new ResizeObserver(measure).observe(header);
  if (menu) {
    new MutationObserver(queueUpdate).observe(menu, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
  header.addEventListener("focusin", show);
  mobile.addEventListener("change", resize);
  window.addEventListener("scroll", queueUpdate, { passive: true });
  window.addEventListener("resize", resize, { passive: true });
  window.addEventListener("pageshow", resize);
  resize();
  requestAnimationFrame(() => header.classList.add("is-scroll-ready"));
};
